import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { CallType } from 'features/call/call-base/enums';
import { callTypeSelector } from 'features/call/call-base/store/selectors';
import type { ReportType } from 'features/call/vrs-call-comments/enums';
import {
  closeCallAfterReport,
  resetCallComments,
  selectIsAnyPreviousCallMode,
  setReportType,
} from 'features/call/vrs-call-comments/store';
import { useVrsCallFinishConference } from 'features/call/vrs-conference-call/hooks';
import { PageRoute } from 'features/router/routes';

export const useVrsCallCommentsHandlers = (displayCalls: any[]) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const callType = useAppSelector(callTypeSelector);
  const { handleCloseCallVrsConference } = useVrsCallFinishConference();

  // Use the new combined selector instead of computing manually
  const isAnyPreviousCallMode = useAppSelector(selectIsAnyPreviousCallMode);

  const handleReportTypeClick = (reportType: ReportType) => {
    if (isAnyPreviousCallMode && displayCalls.length === 0) {
      return; // Don't proceed if in previous call mode but no calls are available
    }
    dispatch(setReportType(reportType));
  };

  const handleReadyForMoreCalls = () => {
    if (callType === CallType.CONFERENCE_CALL) {
      handleCloseCallVrsConference(true);
    } else {
      dispatch(closeCallAfterReport());
    }
  };

  const handleCancel = () => {
    if (isAnyPreviousCallMode) {
      navigate(PageRoute.MAIN);
      // TODO: Handle report from in waiting for call.
      dispatch(resetCallComments());
    } else {
      handleReadyForMoreCalls();
    }
  };

  return {
    handleReportTypeClick,
    handleReadyForMoreCalls,
    handleCancel,
  };
};
